import { isEqual } from "lodash";
import { LatestReadings } from "./latestReadings";
import { LiveDataLookups } from "@/pages/live-data/models/toLiveDataRow";

/**
 * The diagnostics whose name, unit or source differs between two sets of lookups.
 *
 * Compared by value: a refetch hands over new objects for diagnostics that did not change, and
 * those must not count, or every refetch rebuilds the whole fleet.
 */
export function changedDiagnosticIds(
  previous: LiveDataLookups,
  next: LiveDataLookups,
): Set<string> {
  const changed = new Set<string>();

  for (const part of ["diagnostics", "units", "sources"] as const) {
    const before: Record<string, unknown> = previous[part];
    const after: Record<string, unknown> = next[part];

    for (const id of new Set([...Object.keys(before), ...Object.keys(after)])) {
      if (!isEqual(before[id], after[id])) {
        changed.add(id);
      }
    }
  }

  return changed;
}

/** The vehicles whose newest readings include at least one of `diagnosticIds`. */
export function devicesHoldingAny(
  readings: LatestReadings,
  diagnosticIds: ReadonlySet<string>,
): string[] {
  if (diagnosticIds.size === 0) {
    return [];
  }

  const devices: string[] = [];

  for (const [deviceId, byDiagnostic] of readings) {
    for (const diagnosticId of byDiagnostic.keys()) {
      if (diagnosticIds.has(diagnosticId)) {
        devices.push(deviceId);
        break;
      }
    }
  }

  return devices;
}
